import * as React from 'react';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { OMBUD_COMPLETION_MIMETYPES } from '../../OmbudCompletion/OmbudCompletion.mimetypes';
import { translateFunc } from 'sos-common/js/utils/translations';
import { FormFieldFile } from 'sos-common/js/commonTypes/formField.types';
import { filesMap } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { ValidationResult } from 'sos-common/js/commonTypes/validation.types';
import { ClientErrorsState } from 'sos-common/js/commonTypes/FormBaseStore.types';
import { clientError } from 'sos-common/js/commonTypes/ClientError.types';
import { addFileActionFunc, clearError, removeFileActionFunc } from 'sos-eservice-common/js/Redux/Actions';
import { getErrorMessageByFieldName } from 'sos-common/js/utils/helpers';

export interface OmbudFormFilesProps {
  Translate?: translateFunc;
  postFile: addFileActionFunc;
  deleteFile: removeFileActionFunc;
  clearError: clearError;
  errors: ClientErrorsState;
  files: filesMap;
  validationResults: ValidationResult[];
}

export interface OmbudFormFilesState {}

/**
 * Ombudsansökan has two file uploaders which is rendered by this component. The component has no internal state; it is controlled component.
 */
export class OmbudFormFiles extends React.Component<OmbudFormFilesProps, OmbudFormFilesState> {
  constructor(props: OmbudFormFilesProps) {
    super(props);

    this.state = {};
  }

  public addFiles = (field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.postFile(field);
  };
  public removeFile = (file: FileExtendedDetails, fieldName: string, field: FormFieldFile) => {
    this.props.clearError(field);
    this.props.deleteFile(file, fieldName);
  };

  public render() {
    const { Translate, files, validationResults, errors } = this.props;
    return (
      <div>
        <Fileupload
          useDesignSystemLayout={true}
          disabled={false}
          heading={Translate('|OmbudsansokanForm|attachFile')}
          upload={Translate('|OmbudsansokanForm|uploadFile')}
          nofilesText={Translate('|OmbudsansokanForm|noFilesUploaded')}
          fieldName="bilagor"
          value={files['bilagor']}
          onAdd={this.addFiles}
          onRemove={this.removeFile}
          max={25}
          mimetype={OMBUD_COMPLETION_MIMETYPES}
          errorMessage={getErrorMessageByFieldName(validationResults, 'bilagor')}
          mandatory={true}
          clientError={errors['bilagor'] as clientError}
          maxFileSize={26214400} //25 mb
        />

        <Fileupload
          useDesignSystemLayout={true}
          disabled={false}
          heading={Translate('|OmbudsansokanForm|warrant')}
          upload={Translate('|OmbudsansokanForm|uploadFile')}
          nofilesText={Translate('|OmbudsansokanForm|noFilesUploaded')}
          fieldName="fullmakt"
          value={files['fullmakt']}
          onAdd={this.addFiles}
          onRemove={this.removeFile}
          mimetype={OMBUD_COMPLETION_MIMETYPES}
          max={1}
          errorMessage={getErrorMessageByFieldName(validationResults, 'fullmakt')}
          mandatory={false}
          clientError={errors['fullmakt'] as clientError}
          maxFileSize={26214400} //25 mb
        />
      </div>
    );
  }
}
